var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{staticStyle:{"background-color":"white"},attrs:{"id":"my-team","width":40,"height":8}})])
}
var staticRenderFns = []

export { render, staticRenderFns }